import React, { useEffect, useState } from "react";
import Particles from "../Particles/Particles";
import Services from "../Services";
import Solutions from "../Solutions";
import WhyUs from "../WhyUs";
import Experience from "../Experience";
import "./homePage.css";
import AcrossIndustries from "../AcrossIndustries";
import BottomPage from "../BottomPage";
const Homepage = () => {
  const [scrollWidth, setScrollWidth] = useState(0);

  const handleScroll = () => {
    const totalHeight =
      document.documentElement.scrollHeight - window.innerHeight;
    const currentScroll = window.scrollY;
    const scrollPercentage = (currentScroll / totalHeight) * 100;
    setScrollWidth(scrollPercentage);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <Particles
        title="Empowering Growth Through Innovation"
        subTitle="Providing comprehensive software solutions that enhance efficiency, traceability, and scalability across industries."
        page="homepage"
      />
      <Experience />
      <Services />
      <Solutions />
      <WhyUs />
      {/* <OurTeam /> */}
      <AcrossIndustries />
      <BottomPage />
    </>
  );
};

export default Homepage;
